import { render } from "./HeroShowcase.vue?vue&type=template&id=fb706faa"
import script from "./HeroShowcase.vue?vue&type=script&lang=js"
export * from "./HeroShowcase.vue?vue&type=script&lang=js"

import "./HeroShowcase.vue?vue&type=style&index=0&id=fb706faa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__